import { useEffect, useState } from 'react'
import { Modal } from 'react-daisyui'
import { CreditCard, X } from 'lucide-react'
import { Button } from 'components/Button'
import Item from './Item'
import { connect } from 'react-redux';
import { StripeActions } from 'store/actions';
import toast from 'react-hot-toast';
import { PortalSpinner } from 'components/PortalSpinner'

let enhancer = connect(null, { ...StripeActions });

const List = ({ open, onClose, onSelect, getSavedPaymentMethods }) => {
  const [selectedId, setSelectedId] = useState(null)
  const [paymentMethods, setPaymentMethods] = useState(null)

  useEffect(() => {
    if (open) 
      loadSavedPaymentMethods();
  }, [open]);

  const loadSavedPaymentMethods = async () => {
    setPaymentMethods(null);
    setSelectedId(null)
    try {
      const _paymentMethods = await getSavedPaymentMethods();
      setPaymentMethods(_paymentMethods);
    } catch (error) {
      toast.error(error.errors || 'Failed to load saved payment methods');
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      backdrop
      className="max-w-lg w-[92%] rounded-3xl border border-gray-100 shadow-2xl bg-white p-0 overflow-hidden"
    >
      <div className="flex items-start justify-between p-6 pb-4 border-b border-gray-100">
        <div className="flex items-center gap-3">
          <div className="p-2.5 rounded-xl bg-blue-50/80 text-blue-600 border border-blue-100/80 shrink-0">
            <CreditCard size={20} />
          </div>
          <div>
            <h2 className="text-lg font-bold text-secondary-900 leading-tight">Saved Payment Methods</h2>
            <p className="text-xs text-secondary-400 mt-0.5">Select a card to continue payment</p>
          </div>
        </div>
        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          className="flex h-9 w-9 items-center justify-center rounded-xl bg-gray-50 text-secondary-400 transition-colors hover:bg-gray-100 hover:text-secondary-600 border border-gray-100 shrink-0"
        >
          <X size={18} />
        </button>
      </div>

      <Modal.Body className="p-6 pt-4 space-y-3 max-h-[60vh] overflow-y-auto">
        {!paymentMethods ? <PortalSpinner />
          : paymentMethods.length === 0 ?
            <div className="text-center py-8">
              <p className="text-secondary-400 text-sm">No saved payment methods found</p>
            </div>
            : paymentMethods.map((method) =>
              <Item
                key={method.id}
                method={method}
                isSelected={selectedId === method.id}
                onSelect={setSelectedId}
              />
            )
        }
      </Modal.Body>

      <div className="p-6 pt-3 border-t border-gray-100 bg-white">
        <Button
          type="button"
          variant="tertiary"
          title="Pay now"
          disabled={!selectedId}
          onClick={() => { onSelect(selectedId); onClose() }}
          className="w-full py-3 text-base rounded-xl font-semibold justify-center"
        />
      </div>
    </Modal>
  )
}

export default enhancer(List)
